export default function backRemember( remember ) {
    let identify = remember.split('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.');
    identify = identify[1].split('Ufgw&ey6Fe0jnm9E$E40Js.OiJKOiJIUzI1NiJnm9e0jn');

    return identify[0];
}